import React, { useEffect } from "react";

import { faBug } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ls from "localstorage-slim";
import { Button } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { getUrlLangPrefix } from "@/utils/Local";

import FaHome from "../assets/icons/faHome.svg";
import useCart from "../hooks/useCart";
import i18n from "../i18n";

interface ErrorComponentProps {
  standalone?: boolean;
}

const ErrorComponent = ({
  standalone = true,
}: ErrorComponentProps): React.JSX.Element => {
  const { t } = i18n;
  const { dispatch, REDUCER_ACTIONS } = useCart();

  useEffect(() => {
    ls.clear();
    dispatch({ type: REDUCER_ACTIONS.RESET });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={`d-flex flex-column justify-content-center align-items-center  h-100 w-100 gap-4 ${standalone ? "position-absolute" : ""}`}
    >
      <FontAwesomeIcon icon={faBug} size="4x" />
      {t("_error_message")}

      <NavLink className="mt-2" to={`${getUrlLangPrefix()}/`}>
        <Button variant="outline-primary d-flex justify-content-center gap-2 ps-4 pe-4 pt-2 pb-2">
          <img alt={t(`home`)} src={FaHome} />
          <span>{t("go_to_homepage")}</span>
        </Button>
      </NavLink>
    </div>
  );
};

export default ErrorComponent;
